/**
 * @fileoverview Shared helpers for turning unknown thrown values into display
 * strings. Prefer this over repeating `error instanceof Error ? error.message`.
 */

/**
 * Extracts a safe message from an unknown error. Non-Error values use
 * `fallback` so call sites keep their previous `instanceof Error` behaviour.
 */
export function getErrorMessage(error: unknown, fallback = 'Unknown error'): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}

/**
 * Returns the first Error message from a list of unknown values, or null
 * when none of them are Errors with a message.
 */
export function firstErrorMessage(...errors: unknown[]): string | null {
  for (const error of errors) {
    if (error instanceof Error && error.message) {
      return error.message;
    }
  }
  return null;
}
